import React from 'react'
import { Props } from './types'

export const CaretDown: React.FC<Props> = (props) => {
  return (
    <svg
      version="1.1"
      x="0px"
      y="0px"
      width="16px"
      height="16px"
      viewBox="0 0 16 16"
      {...props}
    >
      <polygon points="8 13.53 1.15 6.97 2.53 5.52 8 10.76 13.47 5.52 14.85 6.97 8 13.53" />
    </svg>
  )
}
